import script from "./item-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./item-list.vue?vue&type=script&setup=true&lang=ts"

import "./item-list.vue?vue&type=style&index=0&id=9d6912a2&lang=scss&scoped=true"

import exportComponent from "D:\\work\\kaifengzimaoqu\\wt_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d6912a2"]])

export default __exports__